// extracted by mini-css-extract-plugin
export default {"ViewTitle-ocean":"theme-ocean_ViewTitle-ocean__zGjHT"};